import { Button, CheckboxInput } from "@rocketmakers/armstrong";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { useRoutePaths } from "../../../../shared/context/paths";
import { BackButton } from "../../components/buttons/back-button";
import { routePaths } from "../../routes";

export const CheckInstallationView: React.FunctionComponent<RouteComponentProps> = () => {
	const { push } = useRoutePaths();
	const installationChecks = [
		"Ensure all meters and sensors are connected as per installation instructions",
		"Ensure all meters and sensors have the correct setting and those settings have been recorded on the commissioning form",
		"Ensure the IES is powered on",
	];

	const handleContinue = () => push(routePaths.check.checkRouter);

	const [checklist, updateChecklist] = React.useState(installationChecks.map(() => false));
	const hasCompletedChecks = checklist.every((value) => value === true);

	return (
		<>
			<div>
				<BackButton />
				<h1>
					Installation <span className="color-primary">checks</span>
				</h1>

				<div>
					{installationChecks.map((message, idx) => (
						<CheckboxInput
							// rome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							key={idx}
							labelContent={message}
							checked={checklist[idx]}
							onChange={(e) => updateChecklist(checklist.map((value, i) => (idx === i ? e.target.checked : value)))}
						/>
					))}
				</div>

				<div className="row">
					<Button
						data-qa="continue-button"
						className="continue-button btn-full btn-large"
						disabled={!hasCompletedChecks}
						onClick={handleContinue}
					>
						Continue
					</Button>
				</div>
			</div>
		</>
	);
};
